import React from 'react';
import { useIntl } from 'react-intl';

import { useCurrentTheme } from 'app/shared/theme';
import { Box, Icon, Typography } from 'app/shared/components/atoms';
import { ReactComponent as CircleCheck } from 'icons/circle-check.svg';

export const Success = () => {
  const { formatMessage } = useIntl();
  const { colors } = useCurrentTheme();

  return (
    <Box alignItems="center" gap={2}>
      <Icon
        icon={CircleCheck}
        strokeColor={colors.messaging.success.light}
        size="sm"
      />
      <Typography
        as="span"
        display="inline-flex"
        color={colors.messaging.success.light}
      >
        {formatMessage({ id: 'eventCollectionFollow.inlineSuccess' })}
      </Typography>
    </Box>
  );
};
